<div class="sidebar-container" [class.collapsed]="isSidebarCollapsed">
  <!-- Section Toggle Buttons -->
  <div class="section-toggle">
    <button class="toggle-btn" 
            [class.active]="activeSection === 'watchlist'"
            (click)="onSectionToggle('watchlist')"
            [disabled]="watchlistStore.isAnyWatchlistLoading()"
            [class.hidden]="isSidebarCollapsed">
      Your Watchlists
    </button>
    <button class="toggle-btn" 
            [class.active]="activeSection === 'benchmark'"
            (click)="onSectionToggle('benchmark')"
            [disabled]="watchlistStore.isAnyWatchlistLoading()"
            [class.hidden]="isSidebarCollapsed">
      Benchmark Portfolios
    </button>
    <!-- <button class="sidebar-toggle" (click)="toggleSidebar()" [title]="isSidebarCollapsed ? 'Expand Sidebar' : 'Collapse Sidebar'" >
      <i class="bi" [class.bi-chevron-left]="!isSidebarCollapsed" [class.bi-chevron-right]="isSidebarCollapsed" ></i>
    </button>
     -->
  </div>
  <!-- Watchlists Section -->
  <div *ngIf="activeSection === 'watchlist'">
    <h3 class="main-heading" [class.hidden]="isSidebarCollapsed">Your Watchlists</h3>
    
    <!-- Create Section -->
    <div class="create-section">
      <button class="create-btn" style="background:#1F3A8A;color:white;" [class.collapsed]="isSidebarCollapsed" (click)="onCreateWatchlist()" [title]="isSidebarCollapsed ? 'Create Watchlist' : ''">
        <i class="bi bi-plus-circle"></i>
        <span [class.hidden]="isSidebarCollapsed">Create Watchlist</span>
      </button>
    </div>
    
    <!-- Watchlists List -->
    <div class="watchlists-section">
      <div *ngIf="isLoading" class="loading">
        <mat-spinner diameter="20"></mat-spinner>
      </div>

      <div class="list" *ngIf="!isLoading && watchlists.length > 0">
        <button *ngFor="let watchlist of watchlists" 
                class="list-item"
                [class.list-item-active]="selectedWatchlist?.watchlist_id === watchlist.watchlist_id"
                [disabled]="watchlistStore.isAnyWatchlistLoading()"
                (click)="onWatchlistClick(watchlist)"
                [title]="isSidebarCollapsed ? watchlist.watchlist_name : ''">
          <i class="bi bi-folder"></i>
          <span class="watchlist-name" [class.hidden]="isSidebarCollapsed">{{ watchlist.watchlist_name }}</span>
          <span class="watchlist-count" style="background:#E5E7EB;color:#1F2937;"
          [class.hidden]="isSidebarCollapsed">{{ watchlist.company_count || 0 }}</span>
          <button class="edit-btn" (click)="onEditWatchlist(watchlist); $event.stopPropagation()" [class.hidden]="isSidebarCollapsed" [disabled]="watchlistStore.isAnyWatchlistLoading()">
            <i class="bi bi-pencil-square"></i>
          </button>
          <button class="edit-btn" (click)="onDeleteWatchlist(watchlist); $event.stopPropagation()" [class.hidden]="isSidebarCollapsed" [disabled]="watchlistStore.isAnyWatchlistLoading()" style="color: #df483d;">
            <i class="bi bi-trash"></i>
          </button>
        </button>
      </div>
    </div>
  </div>

  <!-- Benchmarks Section -->
  <div *ngIf="activeSection === 'benchmark'">
    <h3 class="main-heading" [class.hidden]="isSidebarCollapsed">Benchmark Portfolios</h3>
    
    <!-- Benchmarks List (Read-only) -->
    <div class="watchlists-section">
      <div *ngIf="isLoading" class="loading">
        <mat-spinner diameter="20"></mat-spinner>
      </div>

      <div class="list" *ngIf="!isLoading && benchmarks.length > 0">
        <button *ngFor="let benchmark of benchmarks" 
                class="list-item"
                [class.list-item-active]="selectedBenchmark?.benchmark_id === benchmark.benchmark_id"
                [disabled]="watchlistStore.isAnyWatchlistLoading()"
                (click)="onBenchmarkClick(benchmark)"
                [title]="isSidebarCollapsed ? benchmark.benchmark_name : ''">
          <span class="watchlist-name" [class.hidden]="isSidebarCollapsed">{{ benchmark.benchmark_name }}</span>
          <span class="watchlist-count" [class.hidden]="isSidebarCollapsed">{{ benchmark.company_count || 0 }}</span>
        
        </button>
      </div>
    </div>
  </div>
</div>
